import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal } from '@reveni-io/reveni-ui'

import InfoParcelsText from './InfoParcelsText/InfoParcelsText'
import * as Styles from './styles'

const PrepareParcelsModal = ({ show, onClose, onPrepareParcels, selectedParcels, loading }) => {
  const { t } = useTranslation()

  const handlePrepareShipments = () => {
    const parcelIds = selectedParcels?.map(parcel => parcel.id)
    onPrepareParcels(parcelIds)
  }

  return (
    <Modal
      title={t('Preparar envíos')}
      show={show}
      size="l"
      onClose={onClose}
      actions={
        <Styles.ActionsContainer>
          <Button variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            onClick={handlePrepareShipments}
            loading={loading}
            loadingLabel={t('Preparando envíos')}
            defaultLabel={t('Preparar envíos')}
            disabled={loading || !selectedParcels?.length}
          />
        </Styles.ActionsContainer>
      }
    >
      <Styles.MainContainer>
        <InfoParcelsText selectedParcels={selectedParcels} />
        <Alert type="warning">{t('Esta acción no se podrá deshacer. ¿Quieres continuar?')}</Alert>
      </Styles.MainContainer>
    </Modal>
  )
}

export default PrepareParcelsModal
